<template>
	
			<div class="mzixunWrap">
				<div class="mzixunLeft white">
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>专业就业</h3>
						</div>
						<div class="plr20">
							<!-- <div class="fenbuBox">
								<div class="zhuanye" id="renshu"></div>
							</div> -->
							<tibiao></tibiao>
						</div>
						<div class="plr20">
							<div class="fenbuBox">
								<div class="itemTile">
									<h3>地区流向</h3>
								</div>
								<ul class="lingyuList">
									<li>
										<h5>上海</h5>
										<div class="xian">
											<span style="width: 21%;"></span>
										</div>
										<h6>21%</h6>
									</li>
									<li>
										<h5>深圳</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>北京</h5>
										<div class="xian">
											<span style="width: 18%;"></span>
										</div>
										<h6>18%</h6>
									</li>
									<li>
										<h5>广州</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>杭州</h5>
										<div class="xian">
											<span style="width: 31%;"></span>
										</div>
										<h6>31%</h6>
									</li>

									<li>
										<h5>武汉</h5>
										<div class="xian">
											<span style="width: 21%;"></span>
										</div>
										<h6>21%</h6>
									</li>
									<li>
										<h5>成都</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>南京</h5>
										<div class="xian">
											<span style="width: 18%;"></span>
										</div>
										<h6>18%</h6>
									</li>
									<li>
										<h5>重庆</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>西安</h5>
										<div class="xian">
											<span style="width: 31%;"></span>
										</div>
										<h6>31%</h6>
									</li>
								</ul>
							</div>
						</div>

						<div class="plr20">
							<div class="fenbuBox">
								<div class="itemTile">
									<h3>奖学金</h3>
								</div>
								<ul class="lingyuList">
									<li>
										<h5>其他企业</h5>
										<div class="xian">
											<span style="width: 21%;"></span>
										</div>
										<h6>21%</h6>
									</li>
									<li>
										<h5>三资企业</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>国有企业</h5>
										<div class="xian">
											<span style="width: 18%;"></span>
										</div>
										<h6>18%</h6>
									</li>
									<li>
										<h5>民营企业</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>机关</h5>
										<div class="xian">
											<span style="width: 31%;"></span>
										</div>
										<h6>31%</h6>
									</li>

									<li>
										<h5>部队</h5>
										<div class="xian">
											<span style="width: 21%;"></span>
										</div>
										<h6>21%</h6>
									</li>
									<li>
										<h5>科研设计单位</h5>
										<div class="xian">
											<span style="width: 17%;"></span>
										</div>
										<h6>17%</h6>
									</li>
									<li>
										<h5>其他</h5>
										<div class="xian">
											<span style="width: 18%;"></span>
										</div>
										<h6>18%</h6>
									</li>
								</ul>
							</div>
						</div>

					</div>
				</div>

				<div class="abstractRight white">
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>毕业方向</h3>
						</div>
						<div class="plr20">
							<div class="fangxiang">
								<div class="item">
									<div class="text">
										<div>
											<span>86.5%</span>
											<h5>就业率</h5>
										</div>
									</div>
								</div>
								<div class="item itemkaoyan">
									<div class="text">
										<div>
											<span>62.5%</span>
											<h5>考研考博率</h5>
										</div>
									</div>
								</div>
								<div class="item itemchu">
									<div class="text">
										<div>
											<span>25.3%</span>
											<h5>出国率</h5>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		

</template>

<script>
	import vHeader from '../../../components/vHeader.vue'
	import zuoxuanfu1 from '../../../components/zuoxuanfu1.vue'
	import item7 from '../../../components/item7.vue'
	import tibiao from "../../tubiao/xueshengjiuye.vue"
	export default {
		name: "",
		components: {
			tibiao,
			vHeader,
			item7,
			zuoxuanfu1
		},
		data() {
			return {
				// 导航选中
				Name:2,
			}
		},
		methods: {

		}


	}
</script>

<style scoped>
	.wrap{background: #FBFBFB;}
	/* 右边固定 */
	.zuotab{height: auto; display: flex;flex-direction: column;position: fixed;top: 50%;right: 0px;transform:translate(-50%,-50%);}
	.zuotab figure{cursor: pointer; margin: 8px 0; width: 64px;height: 62px;border: 1px solid #FF0000;border-radius: 5px;display: flex;flex-direction: column; align-items: center;justify-content: center;}
	.zuotab figure img{width: 20px;height: 20px;}
	.zuotab figure figcaption{font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;margin-top: 10px;}

</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/xyzy_xueshengjiuye.vue